/**
 * ErrorPageChrome — minimal chrome wrapper for all error pages.
 *
 * Per J-X8: error pages use minimal chrome only (BrandMark/wordmark + footer;
 * NOT authed Shell). Mirrors the pattern from pages/auth/sign-in.tsx which
 * uses AuthCard with the cream bg + card layout.
 *
 * Cross-cutting invariants:
 *   - Inv 12: no console.log
 *   - Inv 13: no `any`
 *   - Inv 14: wordmark uses <Link to="/"> (internal nav)
 *   - Inv 15: atoms from @/components/ui barrel
 */
import type { ReactElement, ReactNode } from 'react';
import { Link } from '@/components/ui';

interface ErrorPageChromeProps {
  children: ReactNode;
}

export function ErrorPageChrome({ children }: ErrorPageChromeProps): ReactElement {
  return (
    <div className="min-h-screen bg-bg text-ink flex flex-col">
      <header role="banner" className="border-b border-line bg-card">
        <div className="mx-auto flex max-w-page items-center justify-between px-6 py-5">
          <Link
            to="/"
            aria-label="BIMAssess home"
            className="font-sans text-lg font-medium tracking-tight text-ink no-underline hover:text-accent"
          >
            BIMAssess
          </Link>
        </div>
      </header>
      <main role="main" className="flex flex-1 items-center justify-center px-6 py-20">
        <div className="w-full max-w-md">
          {children}
        </div>
      </main>
      <footer className="border-t border-line bg-card px-6 py-4">
        <div className="mx-auto max-w-page">
          <p className="font-sans text-small text-muted text-center">
            &copy; {new Date().getFullYear()} BIMAssess. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
}
